import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { query } from '@warp-drive/utilities/json-api';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';
import type SessionContextService from 'tio-employee/services/session-context';
import type { Store as StoreService } from '@warp-drive/core';
import type { ObservableDocumentExtension as ObservableDocumentModel } from 'tio-data/data/resources/observable-document.ext';

export default class AuthenticatedReimaginedDocumentsIndexRoute extends Route {
  @service declare reimaginedData: ReimaginedDataService;
  @service declare sessionContext: SessionContextService;
  @service declare store: StoreService;

  async model() {
    const dataSourceInfo = await this.reimaginedData.getDataSourceInfo();
    const personId = this.sessionContext.person.id;

    let observableDocuments: ObservableDocumentModel[] = [];
    if (personId && !this.reimaginedData.isDemoMode) {
      try {
        const { content } = (await this.store.request(
          query<ObservableDocumentModel>('observable-document', {
            'filter[person]': personId,
            include: 'observable-asset',
            sort: '-created-at',
            'page[limit]': 25,
          })
        )) as { content: { data: ObservableDocumentModel[] } };
        observableDocuments = [...content.data];
      } catch {
        // Fail gracefully — show demo/placeholder data
      }
    }

    return { dataSourceInfo, observableDocuments };
  }
}
